import React from 'react';
import {
  ChakraProvider,
} from '@chakra-ui/react';
import Main from './Layouts/Main';
import ClinicProvider from './contexts/ClinicContext';

function App() {
  return (
    <ChakraProvider>
      <ClinicProvider>
        <Main />
      </ClinicProvider>
    </ChakraProvider>
  );
}

export default App;
